/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Update_Failed_ToastInputs */

const en_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update speaker`)
};

const fr_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de la mise a jour du locuteur`)
};

const de_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecheraktualisierung fehlgeschlagen`)
};

const it_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile aggiornare l'altoparlante`)
};

const ru_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось обновить информацию о динамике.`)
};

const es_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar el altavoz`)
};

const zh_cn2_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扬声器更新失败`)
};

const ja_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの更新に失敗しました`)
};

const hi_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर को अपडेट करने में विफल`)
};

const pt_pt2_speaker_manager_update_failed_toast = /** @type {(inputs: Speaker_Manager_Update_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar o alto-falante`)
};

/**
* | output |
* | --- |
* | "Failed to update speaker" |
*
* @param {Speaker_Manager_Update_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_update_failed_toast = /** @type {((inputs?: Speaker_Manager_Update_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Update_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_update_failed_toast(inputs)
	if (locale === "de") return de_speaker_manager_update_failed_toast(inputs)
	if (locale === "it") return it_speaker_manager_update_failed_toast(inputs)
	if (locale === "ru") return ru_speaker_manager_update_failed_toast(inputs)
	if (locale === "es") return es_speaker_manager_update_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_update_failed_toast(inputs)
	if (locale === "ja") return ja_speaker_manager_update_failed_toast(inputs)
	if (locale === "hi") return hi_speaker_manager_update_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_update_failed_toast(inputs)
	return en_speaker_manager_update_failed_toast(inputs)
});